import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PrivacyContextType {
  valuesHidden: boolean;
  togglePrivacy: () => void;
}

const PrivacyContext = createContext<PrivacyContextType | undefined>(undefined);

export const usePrivacy = (): PrivacyContextType => {
  const context = useContext(PrivacyContext);
  if (!context) {
    throw new Error('usePrivacy must be used within a PrivacyProvider');
  }
  return context;
};

interface PrivacyProviderProps {
  children: ReactNode;
}

export const PrivacyProvider: React.FC<PrivacyProviderProps> = ({ children }) => {
  const [valuesHidden, setValuesHidden] = useState(false);

  const togglePrivacy = () => {
    setValuesHidden(prev => !prev);
  };

  return (
    <PrivacyContext.Provider value={{ valuesHidden, togglePrivacy }}>
      {children}
    </PrivacyContext.Provider>
  );
};
